<template>
  <div class="page-admin-website">
    <CreateWebsite
      ref="siteCreator"
      :goToSite="true"
      :template="selectedCategory"
      :job="formPayload"
      :companyId="companyId"
      :siteName="siteName"
      :companyCity="companyCity"
      @jobStarted="jobStarted"
    />

    <div class="container">
      <div class="chatbox">
        <div
            key="simple-form"
            class="chat-inner simple-mode">
            <TextInput
              label="Website Name"
              v-model="siteName"
              @input="$v.siteName.$touch()"
            />

            <TextInput
              label="Company Phone"
              v-model="companyPhone"
              @input="$v.companyPhone.$touch()"
            />

            <TextInput
              label="Company City"
              v-model="companyCity"
              @input="$v.companyCity.$touch()"
            />

            <div class="text-input">
              <select v-model="selectedCategorySlug">
                <option selected value="" disabled>Select a Category</option>
                <option
                  v-for="(category, index) in categories"
                  :key="`${category.slug}-${index}`"
                  :value="category.slug"
                  >{{ category.name }}</option
                >
              </select>
            </div>

            <hr>

            <div class="input is-checkbox">
              <div class="input-wrapper">
                <input
                  :id="_uid"
                  type="checkbox"
                  @change="$v.createSubscription.$touch()"
                  v-model="createSubscription"
                />
                <label :for="_uid">Create Subscription</label>
              </div>
            </div>

            <div class="create-site-btn">
              <Btn
                isBlock
                primary
                :isLoading="loading"
                @click="createSite">
                Create My Site
              </Btn>
            </div>
          </div>

        <div class="restart-btn">
          <p v-if="isCreating">Creating your website... About {{secondsRemaining}} seconds remaining!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {readCompanyData} from '@/lib/companies'
import {readTemplatesData, readTemplateDataBySlug} from '@/lib/templates'

import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import {errorMessages} from '@/lib/error_messages'

import {mapGetters} from 'vuex'

import Page from '@/mixins/page'

import TextInput from '@/components/forms/inputs/TextInput'
import CreateWebsite from '@/components/SiteSetup/CreateWebsite'
import Btn from '@/components/Btn'

export default {
  name: 'admin-create-website',

  mixins: [validationMixin, Page],

  data() {
    return {
      secondsRemaining: 30,
      currentAnswer: '',
      siteName: '',
      companyCity: '',
      companyPhone: '',
      selectedCategorySlug: '',
      selectedCategory: {},
      errors: {},
      company: {},
      categories: [],
      isCreating: false,
      createSubscription: false,
      title: 'Create customer website'
    }
  },

  props: {
    companyId: String
  },

  components: {
    TextInput,
    CreateWebsite,
    Btn
  },

  computed: {
    ...mapGetters(['loading']),
    ...errorMessages([
      'siteName',
      'companyPhone',
      'companyCity',
      'selectedCategorySlug',
      'createSubscription'
    ]),

    companyEmail() {
      return this.company.email
    },

    companyOwnerId() {
      return this.company.owner_id
    },

    formPayload() {
      return {
        userId: this.companyOwnerId,
        siteName: this.siteName,
        companyPhone: this.companyPhone,
        companyOwnerId: this.companyOwnerId,
        createSubscription: this.createSubscription,
        seoDescription:
          'First class business in the local area. Professional and friendly service. Hundreds of satisfied customers.',
        sitePageNames: ['Home', 'Services', 'Gallery', 'Reviews', 'Contact'],
        sitePageSlideHeadings: [
          'Welcome',
          'Our Services',
          'Gallery',
          'Our Reviews',
          'Contact Us'
        ],
        sitePagePaths: ['/', '/services', '/gallery', '/reviews', '/contact']
      }
    }
  },

  methods: {
    getData() {
      readTemplatesData().then(({data}) => {
        this.categories = data
      })

      readCompanyData(this.companyId).then(({data}) => {
        this.company = data
      })
    },

    jobStarted() {
      this.isCreating = true
      this.handleCountdown()
    },

    handleCountdown() {
      let seconds = 30

      let timer = setInterval(() => {
        seconds = --seconds
        this.secondsRemaining = seconds

        if (seconds === 0) {
          clearInterval(timer)
        }
      }, 1000)

      return timer
    },

    getCategoryData() {
      readTemplateDataBySlug(this.selectedCategorySlug)
        .then(({data}) => {
          this.selectedCategory = data
        })
    },

    createSite() {
      this.$refs.siteCreator.startJob()
    }
  },

  validations: {
    siteName: {required},
    companyPhone: {required},
    companyCity: {required},
    selectedCategorySlug: {required},
    firstName: {required},
    createSubscription: {required}
  },

  mounted() {
    this.getData()
  },

  watch: {
    selectedCategorySlug() {
      this.getCategoryData()
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.page-admin-website

  .chatbox
    @extend %card
    min-height: 675px
    max-width: 600px
    border-radius: 0
    width: 100%
    margin: $gap-large auto
    padding: $gap-small
    position: relative
    display: flex
    flex-direction: column
    justify-content: space-between

    @include media($media-gt-medium)
      padding: $gap-medium
      border-radius: 5px

    .chat-inner
      background: #f7f7f7
      padding: 0 $gap-small $gap-small
      flex-grow: 1
      display: flex
      flex-direction: column
      justify-content: space-between
      overflow: hidden
      position: relative

      &.simple-mode
        display: block
        position: relative

        .btn
          margin: $gap-large auto
          display: block
          font-size: 14px

    .create-site-btn
      text-align: center
</style>
